export default function SimpleProcess() {
  const handleCTAClick = () => {
    window.open('https://lin.ee/luTEHR8', '_blank');
  };

  return (
    <section className="py-20 px-6 bg-[#FFF8F3]">
      <div className="max-w-[1000px] mx-auto">
        <h2 className="text-3xl font-bold text-[#5A4033] text-center mb-16">
          進み方はとてもシンプル。
        </h2>

        <div className="space-y-20 mb-20">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0 w-20 h-20 bg-[#F2A67E] rounded-full flex items-center justify-center">
              <span className="text-white text-3xl font-bold">1</span>
            </div>
            <div className="flex-1">
              <h3 className="text-[#5A4033] font-bold text-xl mb-3">
                LINEで今の状況を送る
              </h3>
              <p className="text-[#5A4033] leading-relaxed">
                決まっていない状態でも問題ありません。<br />
                不安・迷い・引っかかっている点を、そのまま言葉にしてください。
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0 w-20 h-20 bg-[#F2A67E] rounded-full flex items-center justify-center">
              <span className="text-white text-3xl font-bold">2</span>
            </div>
            <div className="flex-1">
              <h3 className="text-[#5A4033] font-bold text-xl mb-3">
                話しながら方向性を明らかにする
              </h3>
              <p className="text-[#5A4033] leading-relaxed">
                LINEのビデオ通話やZoomなどを使い、状況を丁寧に確認します。<br />
                何を優先すべきか、どこに注意すべきかを一緒に見極めます。
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0 w-20 h-20 bg-[#F2A67E] rounded-full flex items-center justify-center">
              <span className="text-white text-3xl font-bold">3</span>
            </div>
            <div className="flex-1">
              <h3 className="text-[#5A4033] font-bold text-xl mb-3">
                提案を受け、次の一手を決める
              </h3>
              <p className="text-[#5A4033] leading-relaxed">
                状況に応じた考え方や選択肢、現実的なアドバイスをお伝えします。<br />
                「これなら進める」と納得できる状態で、次の行動を選べます。
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-8">
          <p className="text-[#5A4033] text-lg font-medium">
            迷っている今こそ、一度話してみてください
          </p>
        </div>

        <div className="flex justify-center">
          <button
            onClick={handleCTAClick}
            className="bg-[#F2A67E] text-white px-12 py-5 rounded-xl text-lg font-bold hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:scale-[1.03] duration-250 ease-out flex items-center gap-3"
          >
            <i className="ri-line-fill text-2xl"></i>
            今の迷いをLINEでそのまま送る
          </button>
        </div>
      </div>
    </section>
  );
}